import { render, staticRenderFns } from "./ContentCardWide.vue?vue&type=template&id=63e95376&"
import script from "./ContentCardWide.vue?vue&type=script&lang=js&"
export * from "./ContentCardWide.vue?vue&type=script&lang=js&"
import style0 from "./ContentCardWide.vue?vue&type=style&index=0&id=63e95376&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports